<template>
    <div>
        <div class="flex w-full flex-row flex-wrap flex-xl-nowrap"  v-show="show">
            <div class="w-1/2 pr-1 lg:pl-1 xl:pl-0 xl:pr-0 lg:w-1/5 xl:w-1/6 xl:mr-2 mb-1 lg:mb-0">
                <label class="text-sm text-grey-darkest">Filter by Fixed Date</label>
                <multiselect :options="dateRanges"
                            v-model="selectedFixedDateRangeIdentifier"
                            :show-labels="false"
                            @input="setFixedDateRange(selectedFixedDateRangeIdentifier)"
                            @remove="clearDates"
                             :disabled="filtersDisabled"
                            track-by="id" label="name" class="mb-2 cursor-pointer">
                </multiselect>
            </div>
            <div class="w-1/2 pr-1 lg:pl-1 xl:pl-0 xl:pr-0 lg:w-1/3 xl:w-1/4 xl:mr-2 mb-1 lg:mb-0">
                <div class="flex">
                    <v-date-picker v-model="selectedDateRange" is-range :masks="rangeMask" @input="setFixedDateRange({id:0})" :popover="{ visibility: 'click' }">
                        <template v-slot="{ inputValue, inputEvents }">
                            <div class="flex w-full">
                                <div class="flex-column mr-2">
                                    <label class="text-sm text-grey-darkest">Start Date</label>
                                    <input
                                        :disabled="filtersDisabled"
                                        :value="inputValue.start"
                                        v-on="inputEvents.start"
                                        class=" mr-1 cursor-pointer date-picker-input border-1 border-grey focus:outline-none px-2 rounded-l rounded-r text-grey-darkest text-sm w-full"
                                    />
                                </div>
                                <div class="flex-column">
                                <label class="text-sm text-grey-darkest">End Date</label>
                                    <input
                                        :disabled="filtersDisabled"
                                        :value="inputValue.end"
                                        v-on="inputEvents.end"
                                        class="cursor-pointer date-picker-input border-1 border-grey focus:outline-none px-2 rounded-l text-grey-darkest text-sm w-full"
                                    />
                                </div>
                            </div>
                        </template>
                    </v-date-picker>
                    <div class="flex-column">
                        <label class="text-sm text-grey-darkest"></label>
                        <div
                            class="-ml-0 border-b-1 border-grey border-r-1 border-t-1 cursor-pointer flex hover:bg-grey hover:text-white text-grey-darkest items-center px-2 rounded-r cross-btn"
                            @click.stop="clearDates">
                            <i class="material-icons text-sm">clear</i>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="reportType != 2" class="w-1/2 pr-1 lg:pl-1 xl:pl-0 xl:pr-0 lg:w-1/5 xl:w-1/6 xl:mr-2 mb-1 lg:mb-0">
                <label class="text-sm text-grey-darkest">Filter by User</label>
                <multiselect
                    class="cursor-pointer"
                    :options="users"
                    v-model="selectedUser"
                    :show-labels="false"
                    track-by="id"
                    label="name"
                    :disabled="filtersDisabled"
                    :multiple="true">
                </multiselect>
            </div>
            <div class="w-1/2 lg:w-1/5 xl:w-1/6 pr-1 lg:pl-1 xl:pl-0 xl:pr-0 xl:mr-2">
                <label class="text-sm text-grey-darkest">Filter by {{ getFieldLabel(fieldLabels , 'office') }}</label>
                <multiselect
                    :options="offices"
                    v-model="selectedOffice"
                    :show-labels="false"
                    track-by="id"
                    group-values="offices"
                    group-label="label"
                    :group-select="true"
                    label="code"
                    :disabled="filtersDisabled"
                    :multiple="true"
                    class="mb-2 cursor-pointer">
                </multiselect>
            </div>
            <div class="w-1/2 lg:w-1/5 xl:w-1/6 pr-1 lg:pl-1 xl:pl-0 xl:pr-0 xl:mr-2">
                <div>
                    <label class="text-sm text-grey-darkest">Filter by {{ getFieldLabel(fieldLabels , 'contract-type') }} </label>
                    <multiselect :options="contractTypes"
                                v-model="selectedContractType"
                                :show-labels="false"
                                track-by="id" group-values="contractTypes"
                                 group-label="label"
                                 :disabled="filtersDisabled"
                                 :group-select="true" label="code" class="mb-2 cursor-pointer" :multiple="true">
                    </multiselect>
                </div>
            </div>
            <div class="w-1/2 lg:w-1/5 xl:w-1/6 pl-1 lg:pr-1 xl:pl-0 xl:mr-2" v-if="redirectUrl !== '/home'">
                <div>
                    <label class="text-sm text-grey-darkest">Filter by Stage</label>
                    <multiselect :options="stages"
                                 v-model="selectedStage"
                                 :show-labels="false"
                                 track-by="id" label="full_description" class="mb-2 cursor-pointer">
                    </multiselect>
                </div>
            </div>
            <div class="w-1/2 lg:w-1/5 xl:w-1/6 pl-1 lg:pr-1 xl:pl-0 xl:mr-2" v-if="redirectUrl == '/home'">
                <div>
                    <label class="text-sm text-grey-darkest">Filter by Report Type</label>
                    <multiselect :options="reportTypes"
                                v-model="selectedReportType"
                                 @select="disableFilters"
                                :show-labels="false"
                                track-by="id" label="code" class="mb-2 cursor-pointer">
                    </multiselect>
                </div>
            </div>
            <div class="w-1/2 lg:w-1/5 xl:w-1/6 pl-1 lg:pr-1 xl:pl-0 xl:mr-2" v-if="redirectUrl != '/home'">
                <label class="text-sm text-grey-darkest">Filter by Report Type</label>
                <multiselect :options="reportPMTypes"
                             v-model="selectedPMReportType"
                             :show-labels="false"
                             track-by="id" label="code" class="mb-2 cursor-pointer">
                </multiselect>
            </div>
            <div class="mt-3 py-3 lg:mt-8 w-full lg:w-1/5 xl:w-1/6">
                <div class="row w-full px-4 justify-between">
                    <div class="flex text-center">
                        <button
                            class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-10 md:px-3 rounded-full text-followup-nav"
                            @click="applyFilter" type="button">
                            Apply
                        </button>
                   </div>
                    <div class="flex items-center">
                        <div class="text-2xl cursor-pointer">
                            <span class="material-icons hover:text-followup-nav" @click="show = !show">close</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div  v-show="!show" class="flex w-full flex-row justify-end text-2xl mb-3 cursor-pointer">
            <i class="material-icons hover:text-followup-nav" @click="show = !show">more_vert</i>
        </div>
    </div>
</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import Multiselect from 'vue-multiselect';
    import moment from 'moment';
    // import 'v-calendar/lib/v-calendar.min.css';
    const mobileView = window.screen.width
    export default {
        name: 'home-page-filter',

        components: {Datepicker, Multiselect},
        props: [
            'date-range',
            'fixed-date-range-identifier',
            'user',
            'office',
            'contract-type',
            'contractTypeIds',
            'reportType',
            'redirectUrl',
            'masks',
            'userIds',
            'fieldLabels',
            'hasQrveyAccess',
            'customReportTypes'
        ],

        created() {
            this.fetchData();
            this.getContractTypes();
            this.getOffices();
            if (this.redirectUrl !== '/home') {
                this.getPMReportType();
                this.getStages();
            } else {
                this.getReportType();
            }
        },

        mounted() {
            this.mobileView(mobileView)
        },

        data() {
            return {
                rangeMask: {
                    input: this.masks.moment_mask,
                },
                dateRanges: [],
                users: [],
                // selectedUser: this.user ? this.user : null,
                selectedUser: [],
                selectedDateRange: this.dateRange ? {
                    start: moment(this.dateRange.start).format('MM/DD/YYYY'),
                    end: moment(this.dateRange.end).format('MM/DD/YYYY'),
                } : null,
                selectedFixedDateRangeIdentifier: this.fixedDateRangeIdentifier !== null ? this.fixedDateRangeIdentifier : null,
                offices: [
                    {
                        label: 'All',
                        offices:[]
                    }
                ],
                selectedOffice: [],
                contractTypes: [{
                    label: 'All',
                    contractTypes:[],
                }],
                selectedContractType: [],
                show: true,
                reportTypes: [
                    {
                        id: 0,
                        code: 'Sales',
                        type: 'system'
                    },
                    {
                        id: 1,
                        code: 'Gross Margin',
                        type: 'system'
                    },
                    {
                        id: 2,
                        code: 'Sales Leader',
                        type: 'system'
                    },
                    {
                        id: 3,
                        code: 'Closing Ratio',
                        type: 'system'
                    },
                    ...this.customReportTypes
                ],
                reportPMTypes: [
                    {
                        id: 0,
                        code: 'Gantt Chart',
                        type: 'system'
                    },
                    {
                        id: 1,
                        code: 'Pie Chart',
                        type: 'system'
                    },
                ],
                selectedReportType: null,
                selectedPMReportType: null,
                selectedStage: null,
                stages: [],
                filtersDisabled: false
            }
        },

        methods: {
            fetchData() {
                let self = this;
                axios.get(route('date-ranges')).then((data) => {
                    self.dateRanges = data.data.dateRanges;
                    self.users = data.data.users;
                    if(this.userIds != null){
                        if(this.userIds.length === 1 && this.userIds[0] === 0){
                            this.selectedUser = [{
                                id: 0,
                                name: 'Company'
                            }]
                        }else{
                            let userIds = this.userIds;
                            this.selectedUser = this.users.filter((element)=>{
                                return userIds.find((aux)=> aux === element.id);
                            });
                        }
                    }
                });
            },

            setFixedDateRange(dateRange) {
                if (!dateRange) return;
                this.selectedFixedDateRangeIdentifier = this.dateRanges[dateRange.id];
                if(dateRange.id > 0)
                    this.selectedDateRange = {
                        start: moment(this.dateRanges[dateRange.id].startDate).format('MM/DD/YYYY'),
                        end: moment(this.dateRanges[dateRange.id].endDate).format('MM/DD/YYYY')
                    };
            },

            clearDates() {
                if (!this.filtersDisabled){
                    this.selectedDateRange = null;
                    this.selectedFixedDateRangeIdentifier = null;
                }
            },

            getOffices() {
                let self = this;
                axios.get(route('home.offices')).then((response) => {
                    self.offices[0].offices = [{id: -1, code: 'Unassigned'}, ...response.data];
                    let office = this.office;
                    if(office) {
                        self.selectedOffice = self.offices[0].offices.filter((element)=>{
                            return office.find((aux)=> aux == element.id);
                        });
                    }
                });
            },

            getContractTypes() {
                let self = this;
                axios.get(route('home.contract-types')).then((response) => {
                    self.contractTypes[0].contractTypes = [{id:-1, code: 'Unassigned'}, ...response.data];
                    let contract = this.contractTypeIds;
                    if(contract) {
                        self.selectedContractType = self.contractTypes[0].contractTypes.filter((element)=>{
                            return contract.find((aux)=> aux == element.id);
                        });
                    }
                });
            },

            getReportType() {
                this.selectedReportType = _.find(this.reportTypes, {id: this.reportType});
               this.disableFilters(this.selectedReportType)
            },

            getPMReportType() {
                this.selectedPMReportType = _.find(this.reportPMTypes, {id: this.reportType});
            },

            applyFilter() {
                let uri = "";
                if (this.selectedDateRange) {
                    uri += "?start-date=" + moment(this.selectedDateRange.start).format('l') + "&end-date=" + moment(this.selectedDateRange.end).format('l');
                } else {
                    uri += "?start-date=&end-date=";
                }

                if (this.selectedFixedDateRangeIdentifier) {
                    uri += "&fixed-date-range-identifier=" + this.selectedFixedDateRangeIdentifier.id;
                }

                if (this.selectedUser) {
                    uri += "&user=" + JSON.stringify(this.selectedUser.map((user) => user.id));
                }

                if (this.selectedContractType) {
                    uri += "&contract-type=" + JSON.stringify(this.selectedContractType.map((contractType) => contractType.id));
                }

                if (this.selectedOffice) {
                    uri += "&office=" + JSON.stringify(this.selectedOffice.map((office)=>office.id));
                }

                if (this.selectedReportType) {
                    uri += "&report-type=" + this.selectedReportType.id;
                }

                if (this.selectedPMReportType) {
                    uri += "&report-type=" + this.selectedPMReportType.id;
                }

                if (this.selectedStage) {
                    uri += "&stage=" + this.selectedStage.id;
                }

                const urlParams = new URLSearchParams(window.location.search);

                if (urlParams.has('type')){
                    uri += "&type=" + urlParams.get('type');
                }

                window.location = this.redirectUrl + uri;
            },
            maxDate(){
                return moment().add(1, 'y').toDate();
            },
            // formatDateRange(startDate,endDate){
            //     console.log('startDate',startDate);
            //     console.log('endDate',endDate);
            //   /*  if(!this.selectedDateRange)
            //         return '';
            //
            //     let dates = this.selectedDateRange;*/
            //     return `${moment(startDate).format(this.masks.moment_mask)} - ${moment(endDate).format(this.masks.moment_mask)}`;
            // },

            getStages() {
                let self = this;
                axios.get(route('home.stages')).then((response) => {
                    self.stages = response.data;
                });
            },
            mobileView(view) {
                if (view <= 550){
                    this.show = false;
                } else {
                    this.show = true;
                }
            },
            disableFilters(selectedReport){
                this.filtersDisabled = false;
                if(![0,1,2,3].includes(selectedReport.id)){
                    this.filtersDisabled = true;
                }
            }
        },

    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
    .date-picker-input {
        padding: .61rem .5rem !important;
    }
    .cross-btn {
        height: 38px;
        margin-top: 7px;
    }
</style>
